<div class="header_search header_search_mobile">
  <div class="title-page">
    <h3>Pontos Críticos</h3>
  </div>
  <div class="content_search">
    <div class="select" *ngIf="!idIndicador && !idEntrega && !idPgIndicador">
      <ng-select id="type_id" class="ng-select-alternative" [items]="types" bindLabel="label" bindValue="id" [(ngModel)]="filtroOrigem" placeholder="Selecione" [clearable]="false">
      </ng-select>
    </div>
    <div class="new-demand">
      <button class="btn-back" type="btn" (click)="mostrarSuperados()">{{superados ? 'Ocultar' : 'Mostrar'}} Superados</button>
    </div>
    <div class="new-demand">
      <button class="btn-back" type="btn" (click)="mostrarExcluidos()">{{excluidos ? 'Ocultar' : 'Mostrar'}} Planos de Ação Excluídos</button>
    </div>
    <div class="new-demand" *ngIf="canCreate">
      <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo Ponto Crítico</a>
    </div>
  </div>
</div>


<ng-container *ngIf="lista?.length == 0">
  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Ponto Crítico/Risco</th>
            <th *ngIf="!idIndicador && !idEntrega && !idPgIndicador">Origem</th>
            <th>Tipo</th>
            <th>Status</th>
            <th>Probabilidade</th>
            <th>Impacto</th>
            <th>Sinaleira</th>
            <th>Atualização</th>
           <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b-radius">
            <td colspan="9" class="text-center">Nenhum registro encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="lista?.length > 0">
  <ng-container *ngFor="let item of lista">
    <div class="system-table table-container system-table-m-b" *ngIf="(item.status == 'Ativo' || superados) && (filtroOrigem == 'todos' || filtroOrigem == item.baseRoute)">
      <div class="system-table-conteiner">
        <table>
          <thead>
            <tr>
              <th>Ponto Crítico/Risco</th>
              <th class="text-center" *ngIf="!idIndicador && !idEntrega && !idPgIndicador">Origem</th>
              <th class="text-center">Tipo</th>
              <th class="text-center">Status</th>
              <th class="text-center" *ngIf="!idPgIndicador">Probabilidade</th>
              <th class="text-center" *ngIf="!idPgIndicador">Impacto</th>
              <th class="text-center" *ngIf="!idPgIndicador">Sinaleira</th>
              <th class="text-center">Atualização</th>
              <th class="text-center btn-icon-td">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="title"><span class="title-span">{{ item.description }}</span></td>
              <td class="text-center" *ngIf="!idIndicador && !idEntrega && !idPgIndicador">{{ item.origemLabel }}</td>
              <td class="text-center">{{ item.nome_tipo }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center" *ngIf="!idPgIndicador">{{ item.critical_probability_name }}</td>
              <td class="text-center" *ngIf="!idPgIndicador">{{ item.critical_impact_name }}</td>
              <td class="status" *ngIf="!idPgIndicador">
                <div [innerHTML]="item?.status_icon"></div>
                <div>{{item?.status_label}}</div>
              </td>
              <td class="text-center">
                <p>{{ item.user }}</p>
                <p>{{ item.ctr_dth_atu }}</p>
              </td>
              <td class="btn-icon-td">
                <div class="btn-icon btn-icon-text">
                  <a class="icon-table m-b-sm" [routerLink]="editarClickHandler(item)" *ngIf="item.permission?.testeCritical">
                    <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                  </a>
                  <span class="icon-table m-b-sm" (click)="deleteClickHandler(item)" *ngIf="item.permission?.testeCritical && item.canDeletePC">
                    <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                  </span>
                  <a class="icon-table icon-table-text m-b-sm" [routerLink]="novaAcaoClickHandler(item)" *ngIf="item.permission?.testeActionFix">
                    Plano de ação
                  </a>
                  <a class="icon-table icon-table-text" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams('pc', item, item.baseRoute)" *ngIf="item.permission?.testeCritical && item.canDeletePC && !idPgIndicador && item?.permission?.canCreateDemand">
                    Nova demanda
                  </a>
                </div>
              </td>
            </tr>
            <tr *ngIf="item.criticalActionsArray && item.criticalActionsArray.length > 0" class="border-b-radius system-table-subtable">
              <td colspan="9">
                <div class="system-table table-container system-table-m-none">
                  <div class="system-table-conteiner">
                    <table>
                      <thead>
                        <tr class="tr-line">
                          <th>Plano de ação</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Término planejado</th>
                          <th class="text-center">Término previsto</th>
                          <th></th>
                          <th class="text-center">Atualização</th>
                          <th class="text-center btn-icon-td">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let value of item.criticalActionsArray">
                          <tr *ngIf="!value?.deleted || excluidos">
                            <td class="title">
                              {{ value?.title }}
                              <div>
                                <div class="responsavel d-inline" *ngIf="value?.resp_nome != '' && value?.resp_nome != null">
                                  <img *ngIf="value?.resp_nome" src="assets/images/svgs/person-fill.svg" alt="Responsavel" [tooltip]="value?.resp_nome" placement="bottom" (click)="viewResonsavel(value)">
                                </div>
                                <div class="d-inline" *ngIf="value?.resp_nome == '' || value?.resp_nome == null">
                                  {{ value?.responsible }}
                                </div>
                                <div class="responsavel d-inline" *ngIf="value?.lockdown_id">
                                  <img src="assets/images/svgs/info-circle-fill.svg" alt="Solicitacao" [tooltip]="'Solicitado nova informação em: ' + value.lockdown_dt + '\n'" placement="bottom" (click)="viewSolicitacao(value)">
                                </div>
                              </div>
                            </td>
                            <td class="status">
                              <div>{{ value?.status }}</div>
                            </td>
                            <td class="text-center">{{ value?.deadline_original }}</td>
                            <td class="text-center">{{ value?.deadline }}</td>
                            <td class="status">
                              <div [innerHTML]="value?.status1"></div>
                              <div><strong class="text-error">{{ value?.diff_days }}</strong></div>
                            </td>
                            <td class="text-center">
                              <div>{{ value?.user }}</div>
                              <div>{{ value?.ctr_dth_atu }}</div>
                            </td>
                            <td class="btn-icon-td">
                              <div class="btn-icon btn-icon-text" *ngIf="!value?.deleted">
                                <a class="icon-table m-b-sm" [routerLink]="editarAcaoClickHandler(value, item.id, item.baseRoute)">
                                  <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                                </a>
                                <span class="icon-table m-b-sm" (click)="verSituacaoClickHandler(value)">
                                  <img src="assets/images/svgs/arrows-{{this.showSituacao[value.id] ? 'close' : 'open'}}.svg" alt="Mostrar situação" tooltip="Mostrar situação" placement="bottom">
                                </span>
                                <a class="icon-table icon-table-text m-b-sm" [routerLink]="novaSituacaoClickHandler(value, item.id, item.baseRoute)" *ngIf="value?.testCreatePermission">
                                  Nova situação
                                </a>
                                <span class="icon-table icon-table-text m-b-sm" (click)="solicitarNovaSituacaoClickHandler(item)" *ngIf="item.permission?.testeActionFixNewSit">
                                  Solicitar situação
                                </span>
                                <a class="icon-table icon-table-text" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams('pa', value, item.baseRoute)" *ngIf="!idPgIndicador && item.permission?.canDemand && item?.permission?.canCreateDemand">
                                  Nova demanda
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="showSituacao[value?.id]" class="table-secondary">
                            <td class="title">
                              <strong>Situação:</strong>
                            </td>
                            <td colspan="8">
                              {{ value?.description }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-container>

<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>
<app-modal-solicitacao #modalSolicitacao></app-modal-solicitacao>
